import script from "./InspectorModel.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectorModel.vue?vue&type=script&setup=true&lang=js"

import "./InspectorModel.vue?vue&type=style&index=0&id=21b5ae05&lang=scss"

const __exports__ = script;

export default __exports__